import ExamSectionTemplate from '@/pages/ExamSectionTemplate';

const faqs = [
  {
    question: "What is CBEAA certification?",
    answer: "CBEAA (Competency-Based Examination for Aesthetic Assistants) validates competency for clinical assistants supporting aesthetic medicine procedures. It assesses tray setup, sterility protocols, clinical documentation, patient preparation, and equipment management skills."
  },
  {
    question: "Can clinical assistants perform aesthetic procedures with CBEAA?",
    answer: "No, CBEAA certification does not authorize medical or injectable procedures. Clinical assistants must work under direct supervision of qualified medical practitioners at all times. This certification validates support-level competencies only."
  },
  {
    question: "What are the eligibility requirements for CBEAA?",
    answer: "CBEAA requires a diploma or recognized institutional training in healthcare support, certificate in aesthetic assistance, minimum 6 months experience in clinical aesthetic settings, reference from a supervising medical practitioner, and evidence of sterility and safety protocol training."
  },
  {
    question: "How does the CBEAA examination differ from other certifications?",
    answer: "CBEAA is shorter and focused on support roles. It includes a Written Knowledge Assessment and OSCE Simulation for practical skills. Unlike medical certifications, CBEAA certification is valid for 3 years (not 5) and has lower CPD requirements."
  },
  {
    question: "What tasks can a CBEAA-certified assistant perform?",
    answer: "CBEAA-certified assistants can perform tray setup and preparation, maintain sterility protocols, handle clinical documentation, prepare patients for procedures, manage equipment, and support practitioners during procedures - all under direct supervision."
  },
  {
    question: "What career opportunities does CBEAA provide?",
    answer: "CBEAA certification qualifies individuals for clinical assistant roles in aesthetic clinics, cosmetic surgery centers, dermatology practices, and medi-spas. It demonstrates validated competency in clinical support functions to employers."
  }
];

export default function ClinicalAssistancePage() {
  return (
    <ExamSectionTemplate
      sectionTitle="Section of Clinical Aesthetic Assistance"
      examCode="CBEAA"
      ipcfBadge="Levels 4–5 Clinical Support Certification"
      examFullName="Competency-Based Examination for Aesthetic Assistants"
      testIdPrefix="cbeaa"
      fee="₹22,000"
      faqs={faqs}
      overview="CBEAA validates competency for clinical assistants supporting aesthetic medicine procedures. The examination assesses knowledge and skills in tray setup, sterility protocols, clinical documentation, patient preparation, and equipment management essential for support roles in aesthetic clinics."
      eligibility={[
        'Diploma or recognized institutional training in healthcare support',
        'Certificate in aesthetic assistance from recognized institution',
        'Minimum 6 months experience in clinical aesthetic settings',
        'Reference from supervising medical practitioner',
        'Evidence of completed training in sterility and safety protocols',
      ]}
      stages={[
        { title: 'Written Knowledge Assessment', desc: 'Written examination covering essential knowledge for aesthetic clinical support.' },
        { title: 'OSCE Simulation', desc: 'Practical assessment of tray setup, sterility protocols, and documentation skills.' },
      ]}
      coreDomains={[
        'Tray Setup & Preparation',
        'Sterility Protocols',
        'Clinical Documentation',
        'Patient Preparation',
        'Equipment Management',
        'Safety Standards',
      ]}
      certificationValidity={[
        'Initial certification valid for 3 years from date of issue',
        'Certificate verifiable through IMCAC public verification portal',
        'Certification title: Certified in Clinical Aesthetic Assistance (IMCAC – CBEAA)',
        'Certification for support-level functions only',
        'Annual compliance declaration required',
      ]}
      recertificationPolicy={[
        'Recertification required every 3 years',
        'Minimum 10 CPD hours per year in relevant activities',
        'Evidence of continued practice under supervision',
        'Updated supervisor verification',
        'Compliance audit by supervising practitioner',
      ]}
      additionalDisclaimer="Certification does not authorize medical or injectable procedures. Clinical assistants must work under direct supervision of qualified medical practitioners at all times. This certification validates support-level competencies only and does not confer any authority for independent clinical practice."
      disclaimer="Certification validates assessed competencies for clinical support roles only and does not authorize any medical, injectable, or independent clinical procedures. Assistants must work under direct supervision of qualified practitioners."
      applyLink="/apply"
    />
  );
}
